export const pathwaysCards = [
  {
    id: "P01",
    files: ["pathways01"],
    scheme: "dark",
    active: true,
    scale: "R",
    captions: ["Build kitchen cabinets"],
  },
  {
    id: "P02",
    files: ["pathways02"],
    scheme: "dark",
    active: true,
    scale: "I",
    captions: ["Develop a new medicine"],
  },
  {
    id: "P03",
    files: ["pathways03"],
    scheme: "dark",
    active: true,
    scale: "A",
    captions: ["Write books or plays"],
  },
  {
    id: "P04",
    files: ["pathways04"],
    scheme: "dark",
    active: true,
    scale: "S",
    captions: ["Help people with personal or emotional problems"],
  },
  {
    id: "P05",
    files: ["pathways05"],
    scheme: "dark",
    active: true,
    scale: "E",
    captions: ["Manage a department within a large company"],
  },
  {
    id: "P06",
    files: ["pathways06"],
    scheme: "dark",
    active: true,
    scale: "C",
    captions: ["Install software across computers on a large network"],
  },
  {
    id: "P07",
    files: ["pathways07"],
    scheme: "dark",
    active: true,
    scale: "R",
    captions: ["Repair household appliances"],
  },
  {
    id: "P08",
    files: ["pathways08"],
    scheme: "dark",
    active: true,
    scale: "I",
    captions: ["Study ways to reduce water pollution"],
  },
  {
    id: "P09",
    files: ["pathways09"],
    scheme: "dark",
    active: true,
    scale: "A",
    captions: ["Compose or arrange music"],
  },
  {
    id: "P10",
    files: ["pathways10"],
    scheme: "dark",
    active: true,
    scale: "S",
    captions: ["Give career guidance to people"],
  },
  {
    id: "P11",
    files: ["pathways11"],
    scheme: "dark",
    active: true,
    scale: "E",
    captions: ["Start your own business"],
  },
  {
    id: "P12",
    files: ["pathways12"],
    scheme: "dark",
    active: true,
    scale: "C",
    captions: ["Operate a calculator"],
  },
  {
    id: "P13",
    files: ["pathways13"],
    scheme: "dark",
    active: true,
    scale: "R",
    captions: ["Assemble electronic parts"],
  },
  {
    id: "P14",
    files: ["pathways14"],
    scheme: "dark",
    active: true,
    scale: "I",
    captions: ["Conduct chemical experiments"],
  },
  {
    id: "P15",
    files: ["pathways15"],
    scheme: "dark",
    active: true,
    scale: "A",
    captions: ["Create special effects for movies"],
  },
  {
    id: "P16",
    files: ["pathways16"],
    scheme: "dark",
    active: true,
    scale: "S",
    captions: ["Perform rehabilitation therapy"],
  },
  {
    id: "P17",
    files: ["pathways17"],
    scheme: "dark",
    active: true,
    scale: "E",
    captions: ["Negotiate business contracts"],
  },
  {
    id: "P18",
    files: ["pathways18"],
    scheme: "dark",
    active: true,
    scale: "C",
    captions: ["Keep shipping and receiving records"],
  },
  {
    id: "P19",
    files: ["pathways19"],
    scheme: "dark",
    active: true,
    scale: "R",
    captions: ["Drive a truck to deliver packages to offices and homes"],
  },
  {
    id: "P20",
    files: ["pathways20"],
    scheme: "dark",
    active: true,
    scale: "I",
    captions: ["Examine blood samples using a microscope"],
  },
  {
    id: "P21",
    files: ["pathways21"],
    scheme: "dark",
    active: true,
    scale: "A",
    captions: ["Paint sets for plays"],
  },
  {
    id: "P22",
    files: ["pathways22"],
    scheme: "dark",
    active: true,
    scale: "S",
    captions: ["Do volunteer work at a non-profit organization"],
  },
  {
    id: "P23",
    files: ["pathways23"],
    scheme: "dark",
    active: true,
    scale: "E",
    captions: ["Market a new line of clothing"],
  },
  {
    id: "P24",
    files: ["pathways24"],
    scheme: "dark",
    active: true,
    scale: "C",
    captions: ["Inventory supplies using a hand-held computer"],
  },
  {
    id: "P25",
    files: ["pathways25"],
    scheme: "dark",
    active: true,
    scale: "R",
    captions: ["Test the quality of parts before shipment"],
  },
  {
    id: "P26",
    files: ["pathways26"],
    scheme: "dark",
    active: true,
    scale: "I",
    captions: ["Develop a way to better predict the weather"],
  },
  {
    id: "P27",
    files: ["pathways27"],
    scheme: "dark",
    active: true,
    scale: "A",
    captions: ["Write scripts for movies or television shows"],
  },
  {
    id: "P28",
    files: ["pathways28"],
    scheme: "dark",
    active: true,
    scale: "S",
    captions: ["Teach a high-school class"],
  },
  {
    id: "P29",
    files: ["pathways29"],
    scheme: "dark",
    active: true,
    scale: "E",
    captions: ["Sell merchandise at a department store"],
  },
  {
    id: "P30",
    files: ["pathways30"],
    scheme: "dark",
    active: true,
    scale: "C",
    captions: ["Stamp, sort, and distribute mail for an organization"],
  },
];
